import { Molecule, wrap } from 'AppReact';
import styled from 'styled-components';
import { Bullet, Title } from './atoms';
import { AssignmentWrapper } from './wrappers';

const template = styled.div`
  display: flex;
  align-items: center;
  margin-left: auto;
`;

export default Molecule({
  template,
  atoms: [
    {
      wrapper: AssignmentWrapper,
      name: 'Completed',
      atoms: [
        {
          component: Bullet,
          name: 'Bullet',
          displayState: ({ }) => ({ color: window?.settings?.primary_color ?? '#1DBD6B' }),
          displayValue: ({ }) => ''
        },
        {
          component: Title,
          name: 'Title',
          displayValue: ({ skill }) => skill.completed.toString(),
        },
      ]
    },
    {
      wrapper: AssignmentWrapper,
      name: 'Assigned',
      atoms: [
        {
          component: Bullet,
          name: 'Bullet',
          displayState: ({ }) => ({ color: '#6457E8' }),
          displayValue: ({ }) => ''
        },
        {
          component: Title,
          name: 'Title',
          displayValue: ({ skill }) => skill.assigned.toString(),
        },
      ]
    },
    {
      wrapper: AssignmentWrapper,
      name: 'Withdrawn',
      atoms: [
        {
          component: Bullet,
          name: 'Bullet',
          renderIf: ({ skill }) => skill?.withdrawn >= 0,
          displayState: ({ }) => ({ color: '#FD5E20' }),
          displayValue: ({ }) => ''
        },
        {
          component: Title,
          name: 'Title',
          renderIf: ({ skill }) => skill?.withdrawn >= 0,
          displayValue: ({ skill }) => skill.withdrawn.toString(),
        },
      ]
    },
    {
      wrapper: AssignmentWrapper,
      name: 'CallBacks',
      atoms: [
        {
          component: Bullet,
          name: 'Bullet',
          displayState: ({ }) => ({ color: '#FFC700' }),
          displayValue: ({ }) => ''
        },
        {
          component: Title,
          name: 'Title',
          displayValue: ({ skill }) => skill.callbacks.toString() || skill.callback.toString(),
        },
      ]
    },
  ],
})